import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import addAccessory from 'rangeConfig/smastad/behaviors/addAccessory';
import removeAllBenchPadsInScene from 'rangeConfig/smastad/behaviors/removeAllBenchPadsInScene';
import removeAllBoxesInScene from 'rangeConfig/smastad/behaviors/removeAllBoxesInScene';
import removeAllClothRailStorageCasesInScene from 'rangeConfig/smastad/behaviors/removeAllClothRailStorageCasesInScene';
import removeAllFrontAccessoriesInScene from 'rangeConfig/smastad/behaviors/removeAllFrontAccessoriesInScene';
import { matchAccessoriesToEntitiesInScene } from 'rangeConfig/smastad/filters/mainMenuProductFilters';

const interiorCategories: ProductListConfig['categories'] = [
  {
    id: 'boxes',
    categoryTitle: 'storageone.productListAccessoriesCategoryShelvesTitle',
    cardsSubtitle: 'typeName, designText communicatedSizeText',
    products: [{ path: 'type', value: ProductType.SMASTAD_BOX }],
    noneOption: {
      title: 'storageone.productListNoShelfOrganisersOptionTitle',
      subtitle: 'storageone.productListNoShelfOrganisersOptionSubtitle',
      behaviors: { removeProducts: [removeAllBoxesInScene] },
      selected: noProductsWithTypesInScene([ProductType.SMASTAD_BOX])
    }
  },
  {
    id: 'hanging-storage-case',
    categoryTitle: 'storageone.productListCategoryTitleClothRail',
    cardsSubtitle: 'typeName, designText communicatedSizeText',
    products: [{ path: 'type', value: ProductType.SMASTAD_HANGING_STORAGE_CASE }],
    noneOption: {
      title: 'storageone.productListNoClothRailOrganisersOptionTitle',
      subtitle: 'storageone.productListNoClothRailOrganisersOptionSubtitle',
      behaviors: { removeProducts: [removeAllClothRailStorageCasesInScene] },
      selected: noProductsWithTypesInScene([ProductType.SMASTAD_HANGING_STORAGE_CASE])
    }
  },
  {
    id: 'bench-pad',
    categoryTitle: 'storageone.productListCategoryTitleBench',
    cardsSubtitle: 'typeName, designText communicatedSizeText',
    products: [{ path: 'type', value: ProductType.SMASTAD_BENCH_PAD }],
    noneOption: {
      title: 'storageone.productListNoBenchPadOptionTitle',
      subtitle: 'storageone.productListNoBenchPadOptionSubtitle',
      behaviors: { removeProducts: [removeAllBenchPadsInScene] },
      selected: noProductsWithTypesInScene([ProductType.SMASTAD_BENCH_PAD])
    }
  }
];

const exteriorCategories: ProductListConfig['categories'] = [
  {
    id: 'front-accessories',
    cardsSubtitle: 'typeName, designText communicatedSizeText',
    products: [
      { path: 'type', value: ProductType.SMASTAD_MIRROR },
      { path: 'type', value: ProductType.SMASTAD_HOOK_CLIP },
      { path: 'type', value: ProductType.SMASTAD_LABEL_HOLDER }
    ],
    noneOption: {
      title: 'storageone.productListNoExteriorAccessoriesOptionTitle',
      behaviors: {
        removeProducts: [removeAllFrontAccessoriesInScene]
      },
      selected: noProductsWithTypesInScene([
        ProductType.SMASTAD_MIRROR,
        ProductType.SMASTAD_HOOK_CLIP,
        ProductType.SMASTAD_LABEL_HOLDER
      ])
    }
  }
];

export const exteriorProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText communicatedSizeText',
  behaviors: {
    productClicked: [addAccessory],
    productDropped: [addProduct]
  },
  productFilters: [matchAccessoriesToEntitiesInScene],
  sortOrder: [{ path: 'name' }],
  cluster: [],
  categories: exteriorCategories
};

export const interiorProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'designText',
  behaviors: {
    productClicked: [addAccessory],
    productDropped: [addProduct]
  },
  productFilters: [matchAccessoriesToEntitiesInScene],
  sortOrder: [{ path: 'name' }],
  cluster: [],
  categories: interiorCategories
};
